import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import RootLayout from '@/layouts/RootLayout';

/**
 * 其他-模块
 */
var other = {
  path: '/without',
  redirect: '/without/ecology',
  component: RootLayout,
  children: [{
    path: 'ecology',
    name: 'Ecology',
    component: function component() {
      return import('@/views/other/ecology');
    },
    meta: {
      title: '' // 生态馆
    }
  }, {
    path: 'brand',
    name: 'Brand',
    component: function component() {
      return import('@/views/other/brand');
    },
    meta: {
      title: '',
      // 品牌馆
      keepAlive: true
    }
  }, {
    path: 'theme',
    name: 'Theme',
    component: function component() {
      return import('@/views/other/theme');
    },
    meta: {
      title: '上新',
      // 上新
      keepAlive: true
    }
  }, {
    path: 'exclusive',
    name: 'Exclusive',
    component: function component() {
      return import('@/views/other/exclusive');
    },
    meta: {
      title: '新人专享',
      keepAlive: true
    }
  },
  // 新人专区进入的确认订单页
  {
    path: 'exclusivePayOrder',
    name: 'ExclusivePayOrder',
    component: function component() {
      return import('@/views/other/exclusive/ExclusivePayOrder.vue');
    },
    meta: {
      title: '确认订单'
    }
  },
  // 第三方登陆授权
  {
    path: 'third/party/authorization',
    name: 'ThirdPartyAuthorization',
    component: function component() {
      return import('@/views/other/thirdParty/authorization');
    },
    meta: {
      title: '第三方登陆授权',
      normal: true // 普通页面，不需要登陆查询信息接口
    }
  }]
};
export default other;